import { Box, Image, Text } from '@chakra-ui/react';

import { StorageManager } from '@storage/index';
import { ProfileAdminProps } from '@components/Header/interface';
import { useMemo } from 'react';
import { Module } from '@models/Module';
import { useGet } from '@hooks/useGet';

export const ProfileAdmin = ({ user }: ProfileAdminProps) => {
	const storage = useMemo(() => new StorageManager('session'), []);
	const module = storage.getItem<Module>('selectedModule');

	const { data: picture, isLoading } = useGet<string>({
		queryKey: ['HomeStudentProblem', module?.CODMODULO, user?.CODCOLIGADA, user?.CODPROF],
		request: {
			endpoint: '/professor/profile-picture',
			params: {
				CODCOLIGADA: user?.CODCOLIGADA,
				RA_OU_PROF: user?.CODPROF,
			},
		},
	});

	return (
		<Box display="flex" alignItems="center">
			<Box display="flex" alignItems="flex-end" mr="13px" flexDirection="column">
				<Text fontSize="12px" fontWeight="bold" color="neutral.200" isTruncated maxW="180px">
					{user?.NOME}
				</Text>

				{user?.TITULACAO && (
					<Text fontSize="11px" fontWeight="light" color="primary.200" m="0">
						Titulação {user?.TITULACAO}
					</Text>
				)}

				{/* <Text fontSize="11px" fontWeight="light" color="primary.200" m="0px">
					{user?.CRMPROF}
				</Text> */}
			</Box>

			<Image
				style={{ borderRadius: '50%', objectFit: 'cover', outline: '2px solid #feb511' }}
				src={isLoading || !picture ? '/images/people.svg' : 'data:image/jpg;base64,' + picture}
				alt="logo-afya"
				h="44px"
				w="44px"
			/>
		</Box>
	);
};
